module.exports = __webpack_public_path__ + "img/transition-6.5ed22af0.png";